// import { wpDialogTime } from '../../utils';
import { encryptStorage } from "@/utils/storage";
import { serverSocket } from "@/config";
// import router from '../../router/index';
import { processSipmovilMessages } from '@/store/modules/chat.js'

const camelToSnakeCase = (str) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

// Timeouts de seguridad (por chat) para apagar el indicador "escribiendo" del
// receptor si no llega un nuevo evento, cubriendo la pérdida del writing:false.
const writingTimeouts = {};

// FEX-1156: robustez del indicador "grabando audio" sin depender de que el emisor
// alcance a mandar recording:false en TODOS los casos (recarga, escape, cambio de
// conversación/pestaña, logout, crash…). Emisor: keep-alive que re-emite true cada
// 2.5s. Receptor: auto-apagado si no llega otro evento en ~6s. Mismo patrón que writing.
let recordingKeepAlive = null;
// Chat para el que estamos emitiendo "grabando". Lo recordamos para poder apagar la
// señal aunque el usuario ya haya cambiado de pestaña/chat (originOpenedChat/openedChat
// ya no apuntarían al chat correcto).
let activeRecordingChatId = null;
const recordingTimeouts = {};

const realtime = {
  namespaced: true,
  state: {
    joinSocket: null,
    sipmovilSocket: null,
    sipmovilNotiSocket: null,
    sipmovilFexIANotiSocket: null,
    notificatorSocket: null,
    isConnectedjoinSocket: false,
    isConnectedsipmovilSocket: false,
    isFailedSipmovilSocket: false,
    isConnectingSipmovilSocket: false,
    isConnectedsipmovilNotiSocket: false,
    isConnectedsipmovilFexIANotiSocket: false,
    isConnectednotificatorSocket: false,
    message: null,
    lastJoinDisconnectedTime: null,
    lastSipMovilDisconnectedTime: null,
  },
  mutations: {
    SOCKET_ON_OPEN(state, webSocket) {
      state.joinSocket = webSocket;
      state.isConnectedjoinSocket = true;
    },
    SOCKET_ON_CLOSE(state) {
      state.isConnectedjoinSocket = false;
    },
    TOGGLE_JOIN_CONNECTING(state, value) {
      state.isConnectedjoinSocket = value;
    },
    SET_MESSAGE(state, message) {
      state.message = message;
    },
    SIPMOVIL_SOCKET_ON_OPEN(state, webSocket) {
      state.sipmovilSocket = webSocket;
      state.isConnectedsipmovilSocket = true;
    },
    SIPMOVIL_SOCKET_ON_CLOSE(state) {
      state.isConnectedsipmovilSocket = false;
      state.isFailedSipmovilSocket = true;
    },
    SIPMOVIL_SET_MESSAGE(state, message) {
      state.message = message;
    },
    TOGGLE_FAILED(state) {
      state.isFailedSipmovilSocket = false;
    },
    TOGGLE_CONNECTING(state, value) {
      state.isConnectingSipmovilSocket = value;
    },
    NOTIFICATION_SOCKET_ON_OPEN(state, webSocket) {
      state.sipmovilNotiSocket = webSocket;
      state.isConnectedsipmovilNotiSocket = true;
    },
    NOTIFICATION_SOCKET_ON_CLOSE(state) {
      state.isConnectedsipmovilNotiSocket = false;
    },
    NOTIFICATION_SET_MESSAGE(state, message) {
      state.message = message;
    },
    NOTIFICATOR_SOCKET_ON_OPEN(state, webSocket) {
      state.notificatorSocket = webSocket;
      state.isConnectednotificatorSocket = true;
    },
    NOTIFICATOR_SOCKET_ON_CLOSE(state) {
      state.isConnectednotificatorSocket = false;
    },
    NOTIFICATOR_SET_MESSAGE(state, message) {
      state.message = message;
    },
    FEXIA_NOTIFICATION_SOCKET_ON_OPEN(state, webSocket) {
      state.sipmovilFexIANotiSocket = webSocket;
      state.isConnectedsipmovilFexIANotiSocket = true;
    },
    FEXIA_NOTIFICATION_SOCKET_ON_CLOSE(state) {
      state.isConnectedsipmovilFexIANotiSocket = false;
    },
  },
  actions: {
    /*
     -------- Apertura socket servidor Join -----------
    */
    async openJoinSocketConnection(
      { dispatch, commit, state },
      { token, userName, agent=undefined, official, fromStart=false }
    ) {
      state.isConnectedjoinSocket = true
      commit("auth/SET_AUTH_PARAMS", { userName, token }, { root: true });
      state.joinSocket = new WebSocket(
        `${serverSocket}/ws/notification/${userName}/${token}/${official}/${agent}`
      );
      commit("SOCKET_ON_OPEN", state.joinSocket);

      state.joinSocket.onopen = (event) => {
        const now = new Date().getTime();
        const lastDisconnectedTime = state.lastJoinDisconnectedTime || 0;
        const timeElapsed = now - lastDisconnectedTime;
        console.log("Websocket open successfully", event);
        if (timeElapsed >= 60000 && fromStart === false) {
          commit("chat/CLOSE_OPENED_CHATS", null, { root: true });
          commit("chat/SET_CHATS", [], { root: true });
          commit("chat/SET_STATE_PAGE", 1, { root: true });
          dispatch("chat/filteredSenders", null, { root: true });
          dispatch('ui/toggleJoinLoading', false, { root: true })
        } 
        state.lastJoinDisconnectedTime = null;
        commit('ui/alert/CLOSE_ALERT', null, { root: true });
      };

      state.joinSocket.onmessage = (event) => {
        // console.log(event.data);
        dispatch("socketMessage", event.data);
      };

      state.joinSocket.onclose = (event) => {
        console.log("Websocket closed!", event);
        dispatch("socketClose", { token, userName, agent, official });
      };
    },
    sendMessage({ state }, event) {
      // the message must be a Object
      const message = {};
      const extraData = {};

      Object.keys(event).forEach((key) => {
        if (key === "eventType") {
          message[camelToSnakeCase(key)] = event[key];
        } else {
          extraData[camelToSnakeCase(key)] = event[key];
        }
      });

      message.data = extraData;

      const parsedMessage = JSON.stringify(message);
      state.joinSocket.send(parsedMessage);
    },
    socketMessage({ commit, dispatch, rootState }, message) {
      const appMessage = JSON.parse(message);
      const { data, eventType } = appMessage;
      const join = encryptStorage.getItem("user").join;
      let isAdmin;
      if (join) {
        isAdmin = join.isAdmin;
      }
      const userName = encryptStorage.getItem("user").Username;
      let chatData = "";
      let isNewChat = "";
      switch (eventType) {
        case "joinSocketOpened":
          /* the socket joinSocket is opened successfully an return the
          qr image path and swith session state */

          if (data.sessionOpen === true) {
            commit("auth/CONNECT_USER", true, { root: true });
            commit("ui/home/GO_TO_CHATS", null, { root: true });
          } else {
            commit("ui/home/TOGGLE_SWITCH", data.switchState, { root: true });
            // commit('ui/home/UPDATE_QR', data.qrPath, { root: true });
          }
          break;
        case "qrUpdate":
          /* the whatsapp time to star session has finished and qr image has
          changed */
          commit("ui/home/UPDATE_QR", data.qrPath, { root: true });
          break;
        case "sessionStarted":
          /* Sipmovil whatsapp server validates the session and app 
          go to chats screen */
          commit("auth/CONNECT_USER", true, { root: true });
          commit("ui/home/GO_TO_CHATS", null, { root: true });
          break;
        case "showRefreshCode":
          /* Embbed whatapp detects that real whatsapp needs user refresh
          qr code manually */
          commit("ui/home/TOGGLE_REFRESH", data.status, { root: true });
          break;
        case "newMessage":
          /* Selenium web detect that new message has been receivedin current
          another chat */
          // solo mostrar el evento si chat.owner es igual al username     
          if (
            (userName === data.owner ||
            isAdmin === true) &&
            (!rootState.conversation.sendingMessage ||
              rootState.chat.openedChat.id !== data.contact_msg)
          ) {
            dispatch("conversation/newMessage", data, { root: true });
            dispatch("chat/updateUnreadJoin", null, { root: true });
          }
          break;
        case "loadingDialogs":
          /* Real whatsappWeb accepts the qr code and whatsapp fake starts to
          load the dialogs */
          commit("ui/home/UPDATE_QR", "", { root: true });
          commit(
            "ui/home/UPDATE_LOADING_MESSAGE",
            "Actualizando conversaciones",
            { root: true }
          );
          commit("ui/home/TOGGLE_LOADING_QR", true, { root: true });
          break;
        case "transferredChat":
          /* este evento se lanza cuando un agente transfiere una conversacion
          al agente de la sesión abierta */
          // solo mostrar el evento si chat.owner es igual al username
          // isNewChat = 0
          // if (!rootState.chat.filteredChats) {
          
          chatData = rootState.chat.chats.filter(
            (x) => x.id === data.id
          );
          isNewChat = chatData.length;
          // } 
          // else {
          //   isNewChat = rootState.ui.customerOptions.renderChats.filter(
          //     (x) => x.id === data.id
          //   ).length;
          // }
          // si la conversacion existe y el dueño es diferente al
          // usuario eliminarla
          if (isNewChat !== 0) {
            dispatch("conversation/setAgentChats", { owner: chatData[0].owner, add: false }, { root: true });
            dispatch("conversation/setAgentChats", { owner: data.owner, add: true }, { root: true });
          }
          if (isNewChat !== 0 && data.state === 'closed') {
            commit("chat/REMOVE_CHATS", data.id, { root: true });
          } else if (isNewChat !== 0 && userName !== data.owner && isAdmin !== true) {
            commit("chat/REMOVE_CHATS", data.id, { root: true });
          } else if (isNewChat !== 0 && userName === data.owner && isAdmin === true) {
            var chatIndex = rootState.chat.chats.findIndex((x) => x.id === data.id, -1);
            var chat = rootState.chat.chats[chatIndex];
            if (!rootState.chat.filteredChats || rootState.chat.filterUnread) {
            //   chatIndex = rootState.ui.customerOptions.renderChats.findIndex((x) => x.id == data.id, -1);
            //   chat = rootState.ui.customerOptions.renderChats[chatIndex];
            //   rootState.ui.customerOptions.renderChats = rootState.ui.customerOptions.renderChats.filter((x) => x.id !== data.id);
            //   chat.unread = 1;
            //   rootState.ui.customerOptions.renderChats.splice(0, 0, chat);
            // } else {              
              rootState.chat.chats = rootState.chat.chats.filter((x) => x.id !== data.id);
              chat.unread = data.unread;
              rootState.chat.chats.splice(0, 0, chat);
            }            
            commit("chat/UPDATE_OWNER_CHAT", data, { root: true })
          } else if (isNewChat !== 0 && isAdmin === true) {
            commit("chat/UPDATE_OWNER_CHAT", data, { root: true })
          }
          if (userName === data.owner) {
            // verificar si el chat existe para no agregarlo nuevamente
            if(rootState.auth_store.userInfo.audioJoin && !rootState.softphone_store.chatNotificationsMuted) {
              dispatch("conversation/alertNewTransfer", data.name, { root: true });
            }
            if (isNewChat === 0) {
              // agregar dialogo al listado de conversaciones
              // data.date_message = wpDialogTime(new Date(data.date_message));
              if (data.label_id !== null) {
                let labels = rootState.ui.labels.labels;
                let labelObject = labels.filter(
                  (x) => x.id === data.label_id
                )[0];
                data.label = labelObject;
              }
              commit("chat/CREATE_CHAT", data, { root: true });
              dispatch("chat/updateUnreadJoin", null, { root: true });
              // dispatch("chat/updateUnread", data.id, { root: true });
              dispatch("conversation/setAgentChats", { owner: data.owner, add: true }, { root: true });
            }
            // mostrar notificacion con los datos de la transferencia
            dispatch(
              "ui/alert/displayAlert",
              {
                message: "Chat transferido",
                description: "Se te transfirio una nueva conversación",
                alertType: "info",
              },
              { root: true }
            );
          }
          break;
        case "messageEvent":
          dispatch("conversation/newEventMessage", data, { root: true });
          break;
        case "updateStatus":
          if ( userName === data.user ) {
            commit(
              "auth/SET_PARAM", {
                paramName: "connected",
                paramValue: data.status
              },
              { root: true }
            );
          }
          break;
        case "updateUnread":
          isNewChat = rootState.chat.chats.findIndex((x) => x.id === data.id, -1);
          if (isNewChat !== -1) {
            chatData = rootState.chat.chats[isNewChat];
            chatData.unread = data.unread;
            dispatch("chat/updateUnreadJoin", null, { root: true });
          }          
          break;
        case "updateLabel":
          isNewChat = rootState.chat.chats.findIndex((x) => x.id === data.chat_id, -1);
          chatData = rootState.chat.chats[isNewChat];
          chatData.label = data.label;
          break;
        default:
          break;
      }
    },
    socketClose({ state, commit, dispatch }, 
      { token="", userName="", agent=undefined, official="", close=false }
    ) {
      if (state.isConnectedjoinSocket === true) {
        state.joinSocket.close();
        if (close===false) {
          if (state.lastJoinDisconnectedTime === null) {
            state.lastJoinDisconnectedTime = new Date().getTime();
          }
          setTimeout(() => {
            if (state.isConnectedjoinSocket === false) {
              commit(
                'ui/alert/DISPLAY_ALERT',
                {
                  title: 'Desconectado',
                  message: 'Join desconectado, por favor valide que su conexión este activa.',
                  alertType: 'error'
                },
                { root: true }
              )
            }
          }, 10000);
          setTimeout(() => {
            dispatch("openJoinSocketConnection",
            { token, userName, agent, official }
            )
          }, 1000);
        }        
        commit("SOCKET_ON_CLOSE");
      }
      // setTimeout(router.go(), 10 * 1000);
    },
    /*
     -------- Apertura socket servidor Sipmovil cuando se abre chat -----------
     */
    async openSipmovilChatConnection(
      { commit, state, dispatch },
      { host, chatId, owner }
    ) {
        commit("TOGGLE_CONNECTING", true);
      commit("TOGGLE_FAILED");
      state.sipmovilSocket = new WebSocket(
        `wss://${host}/ws/chat/${chatId}/${owner}/`
      );
      commit("SIPMOVIL_SOCKET_ON_OPEN", state.sipmovilSocket);
      state.sipmovilSocket.onopen = () => {
        console.log('Websocket open successfully', state.sipmovilSocket);
        commit("TOGGLE_CONNECTING", false);
      };

      state.sipmovilSocket.onmessage = (event) => {
        // console.log('Websocket message received!');
        dispatch("socketSipmovilChatMessage", event);
      };

      state.sipmovilSocket.onclose = (event) => {
        console.log("Websocket closed!", event);
        commit("SIPMOVIL_SOCKET_ON_CLOSE");
      };
    },
    sendSipmovilChatMessage({ state }, event) {
      // the message must be a Object.
      const parsedMessage = JSON.stringify(event);
      state.sipmovilSocket.send(parsedMessage);
    },
    socketSipmovilChatMessage({ commit, rootState }, message) {
      const data = JSON.parse(message.data);
      const command = data.command;
      switch (command) {
        case "messagesWeb":
          if (data.messages.length > 0) {
            commit("conversation/LOAD_SIPMOVIL_MESSAGES", processSipmovilMessages(data.messages), { root: true });
            rootState.chat.totalSipmovilMessages += 20;
          } else {
            rootState.chat.lastSipmovilMessages = true;
          }
          break;
        case "readMsjOnline":
          commit("conversation/READ_LAST_MESSAGE", null, { root: true });
          break;
        case "chat_open":
          commit("chat/UPDATE_CHAT_CONTACTS", data, { root: true });
          break;
        default:
          break;
      }
    },
    socketSipmovilChatClose({ state, commit }) {
      if (state.isConnectedsipmovilSocket === true) {
        state.sipmovilSocket.close();
      }
      commit("SIPMOVIL_SOCKET_ON_CLOSE");
    },
    /*
      -------- Apertura socket servidor Sipmovil para las notificaciones -----------
    */
    openNotificationConnection({ commit, dispatch, state }, { host, userId, initial=false }) {
        state.sipmovilNotiSocket = new WebSocket(
        `wss://${host}/ws/notification/${userId}/`
      );
      commit("NOTIFICATION_SOCKET_ON_OPEN", state.sipmovilNotiSocket);
      state.sipmovilNotiSocket.onopen = () => {
        const now = new Date().getTime();
        const lastDisconnectedTime = state.lastSipMovilDisconnectedTime || 0;
        const timeElapsed = now - lastDisconnectedTime;
        console.log('Websocket open successfully ', state.sipmovilNotiSocket);
        if (timeElapsed >= 60000 && initial === false) {
          commit("chat/CLOSE_OPENED_CHATS", null, { root: true });
          dispatch("chat/fetchSipmovilSenders", false, { root: true });
        }
        state.lastSipMovilDisconnectedTime = null;
        commit('ui/alert/CLOSE_ALERT', null, { root: true });
      };

      state.sipmovilNotiSocket.onmessage = (event) => {
        // console.log(event.data);
        dispatch("socketNotificationMessage", event);
      };

      state.sipmovilNotiSocket.onclose = () => {
        dispatch("socketNotificationClose", { host, userId });
      };
    },
    sendNotificationMessage({ state }, event) {
      const parsedMessage = JSON.stringify(event);
      state.sipmovilNotiSocket.send(parsedMessage);
    },
    // FEX-1156: emite la señal de "grabando audio" por el mismo socket de notificación
    // que writing. Encender: solo SipMóvil, con keep-alive cada 2.5s (para que el
    // receptor pueda auto-apagar a los ~6s si dejo de enviar). Apagar: SIEMPRE, sin
    // importar la pestaña/chat actual, limpiando el keep-alive; así un cambio de
    // pestaña a Join/FexIA no deja la señal pegada. Alcance actual: solo SipMóvil.
    notifyRecording({ state, rootState }, recording) {
      const userInfo = rootState.auth_store.userInfo || {};
      const stopKeepAlive = () => {
        if (recordingKeepAlive) {
          clearInterval(recordingKeepAlive);
          recordingKeepAlive = null;
        }
      };

      if (recording) {
        // Encender: solo SipMóvil y con un chat abierto válido.
        if (rootState.chat.originOpenedChat !== 'sipmovil') return;
        const openedChat = rootState.chat.openedChat;
        if (!openedChat || !openedChat.chatId) return;
        activeRecordingChatId = openedChat.chatId;
      } else {
        // Apagar: no depende del origin/openedChat actual (al cambiar de pestaña ya
        // apuntan a otro sitio) y nunca debe dejar vivo el keep-alive.
        stopKeepAlive();
        if (activeRecordingChatId == null) return; // no había señal activa que apagar
      }

      const payload = {
        chat_id: activeRecordingChatId,
        command: 'recording_audio',
        event_type: 'recording_audio',
        recording,
        idUserSendMsj: userInfo.User_id,
        username: userInfo.Username,
        origin: 'sipmovil',
      };
      const send = () => {
        const s = state.sipmovilNotiSocket;
        if (s && s.readyState === 1) {
          s.send(JSON.stringify(payload));
        } else {
          // Socket caído (logout/desconexión) → auto-terminar el keep-alive.
          stopKeepAlive();
        }
      };

      if (recording) {
        stopKeepAlive(); // reinicia cualquier keep-alive previo
        send();
        recordingKeepAlive = setInterval(send, 2500);
      } else {
        send(); // apaga en el receptor
        activeRecordingChatId = null;
      }
    },
    socketNotificationMessage({ commit, dispatch, rootState }, message) {
      const data = JSON.parse(message.data);
      if(data?.datos?.command === 'new_message' && data?.datos?.forwarded) {
        data.datos.message.forwarded = true;
      }
      const userName = encryptStorage.getItem('user').Username
      const User_id = encryptStorage.getItem('user').User_id
      let command = "";
      try {
        command = data.datos.command;
      } catch {
        command = data.command;
      }
      if (command === undefined) {
        command = data.event;
      }
      switch (command) {
        
        case "new_message":
          if (data.datos.message.author[0] !== userName) { 
            if (rootState.chat.openedChat.chatId === data.datos.chat_id) {
              const event = {
                chatId: data.datos.chat_id,
                User_id: User_id,
              }
              dispatch("conversation/readSipmovilMessageAction", event, {
                root: true,
              });  
            }      
            data.datos.name = data.nameSentMsg;
            dispatch("conversation/newSipmovilChatMessage", data.datos, {
              root: true,
            });  
          } else if (data.datos.kind === "NO_ATTACHED" || data.datos.kind === undefined){
              dispatch("conversation/appendMessage", data.datos, {
              root: true,
            });
          }     
          break;
        case "update_unread":
          dispatch("conversation/markAsReadMessages", { data: data.datos, status: 'read' }, {
            root: true,
          });
          dispatch('chat/updateUnreadSipmovil', null, { root: true });
          break;
        case "writing": {
          const wData = data.data;
          const isSip = wData.origin === "sipmovil";
          const isJoin = wData.origin === "join";
          // No mostrar mi propia escritura (sipmovil)
          if (isSip && rootState.auth_store.userInfo.User_id == wData.id_user_wrinting) break;
          if (isSip) {
            commit("chat/UPDATE_SIPMOVIL_WRITING", wData, { root: true });
          } else if (isJoin) {
            commit("chat/UPDATE_JOIN_WRITING", wData, { root: true });
          }
          // Auto-apagado de seguridad: si no llega un nuevo evento en ~6s, apagar el
          // indicador (por si se pierde el writing:false del emisor).
          if (isSip || isJoin) {
            const key = `${wData.origin}:${wData.chat_id}`;
            if (writingTimeouts[key]) {
              clearTimeout(writingTimeouts[key]);
              delete writingTimeouts[key];
            }
            if (wData.writing) {
              writingTimeouts[key] = setTimeout(() => {
                const off = { ...wData, writing: false };
                if (isSip) commit("chat/UPDATE_SIPMOVIL_WRITING", off, { root: true });
                else commit("chat/UPDATE_JOIN_WRITING", off, { root: true });
                delete writingTimeouts[key];
              }, 6000);
            }
          }
          break;
        }
        // FEX-1156: la otra persona está (o dejó de) grabar una nota de voz. Evento
        // independiente de "writing". El payload llega bajo la clave `data` (data.data),
        // igual que "writing" (el doc de backend decía `datos`, pero el evento real usa `data`).
        case "recording_audio": {
          const rData = data.data || {};
          // No mostrar mi propia grabación.
          if (rootState.auth_store.userInfo.User_id == rData.id_user_recording) break;
          if (rData.origin === "sipmovil") {
            commit("chat/UPDATE_SIPMOVIL_RECORDING", rData, { root: true });
          }
          // Auto-apagado de seguridad: el emisor manda keep-alive (recording:true cada
          // ~2.5s). Si dejan de llegar eventos en ~6s (recarga, escape, cambio de
          // conversación/pestaña, logout, crash del emisor), apagar el indicador solo.
          const rkey = `recording:${rData.origin}:${rData.chat_id}`;
          if (recordingTimeouts[rkey]) {
            clearTimeout(recordingTimeouts[rkey]);
            delete recordingTimeouts[rkey];
          }
          if (rData.recording && rData.origin === "sipmovil") {
            recordingTimeouts[rkey] = setTimeout(() => {
              commit("chat/UPDATE_SIPMOVIL_RECORDING", { ...rData, recording: false }, { root: true });
              delete recordingTimeouts[rkey];
            }, 6000);
          }
          break;
        }
        case "audio_speed_changed": {
          // FEX-1157: cambio de velocidad de notas de voz hecho en otra pestaña/
          // dispositivo del mismo usuario. Actualizamos el store global; los
          // reproductores abiertos aplican el nuevo rate en vivo (watch en PreviewAudio).
          const sData = data.datos || data.data || {};
          if (sData.speed != null) {
            commit("auth_store/SET_PLAYBACK_RATE", Number(sData.speed), { root: true });
          }
          break;
        }
        
        case "user_state_changed": {
          const uData = data.datos || data.data || {};
          commit("chat/UPDATE_SIPMOVIL_ACTIVE", { id: uData.user_id, isActive: uData.is_active }, { root: true });
          break;
        }
        
        case "force_logout": {
          const lData = data.datos || data.data || {};
          if (lData.detail) {
            sessionStorage.setItem("forceLogoutMessage", lData.detail);
          }
          dispatch("socketClose", { close: true });
          dispatch("socketSipmovilChatClose");
          dispatch("socketNotificationClose", { close: true });
          dispatch("socketFexIANotificationClose", { close: true });
          dispatch("socketNotificatorClose", { close: true });
          encryptStorage.removeItem("user");
          encryptStorage.removeItem("token");
          commit("pbxCloud_store/loadLogin", false, { root: true });
          window.location.href = "/";
          break;
        }
        case "delete_messages":
          dispatch("chat/sipmovilDeletedMessage", data.datos, {
            root: true,
          });
          break;
        case "edit_message":
          dispatch("chat/sipmovilEditedMessage", data.datos, {
            root: true,
          });
          break;
        // task_reacciones: reacción creada/actualizada/quitada por cualquier
        // participante. El backend emite la lista COMPLETA y autoritativa de
        // reacciones del mensaje → se reemplaza tal cual (misma fuente que leen
        // módulo y widget). Guard de origen: solo aplica a chats SipMóvil.
        case "message_reaction":
          if (rootState.chat.originOpenedChat === "sipmovil") {
            commit(
              "conversation/SET_MESSAGE_REACTIONS",
              {
                messageId: data.datos.message_id,
                reactions: data.datos.reactions,
              },
              { root: true }
            );
          }
          break;
        case "new_notification":
          if (data.datos.start_datetime) {
            new Notification(
              `Tienes un evento: "${data.datos.activity_type}" de tipo ${data.datos.event_type} programado de ${obtenerHora(data.datos.start_datetime)} a ${obtenerHora(data.datos.end_datetime)} en 15 minutos`
            ).onclick = () => {
              window.focus();
              if (window.location.hash !== "#/pbxCloud/agenda") {
                window.location.hash = "#/pbxCloud/agenda";
              }
            };
          }
          dispatch('ui/notifications/prependNotification', data.datos, { root: true });
          break;
        case "new_call_message":
          if (data.datos.message.author[0] !== userName) { 
            if (rootState.chat.openedChat.chatId === data.datos.chat_id) {
              const event = {
                chatId: data.datos.chat_id,
                User_id: User_id,
              }
              dispatch("conversation/readSipmovilMessageAction", event, {
                root: true,
              });  
            }      
            data.datos.name = data.nameSentMsg;
            dispatch("conversation/newSipmovilChatMessage", data.datos, {
              root: true,
            });  
          } else if (data.datos.kind === "NO_ATTACHED" || data.datos.kind === undefined){
              dispatch("conversation/appendMessage", data.datos, {
              root: true,
            });
          }     
          break;
        case "crm_notification":
           dispatch('fxCrm_store/appendNotificationAction', data.datos, {
             root: true,
           });
          break;
        // Alertas de asignación del CRM (`.claude/alertas_crm/`): llega
        // `{ event, datos: { alert, unseen_items } }` cuando a este usuario le
        // transfieren o asignan interacciones. Solo avisa de las NUEVAS.
        case "crm_assignment_alert":
          dispatch('fxCrm_store/receiveAssignmentAlertSocket', data.datos, {
            root: true,
          });
          break;
        // Aprobaciones (task_3 CA-01): al gestor le resolvieron una solicitud.
        // `datos` = { alert, unseen } (FC-690).
        case "crm_approval_alert":
          dispatch('fxCrm_store/receiveApprovalResolution', data.datos, {
            root: true,
          });
          break;
        // Aprobaciones (FC-686 CA-05, FC-688 CA-05): a quien resuelve le cambia
        // la cola. `datos` = { action, approval, pending_count }.
        case "crm_approval_pending":
          dispatch('fxCrm_store/receiveApprovalPending', data.datos, {
            root: true,
          });
          break;
        case "messages_read":
          console.log('[WS] messages_read recibido:', data.datos);
          dispatch("conversation/handleMessagesRead", data.datos, { root: true });
          break;
        case "message_sent":
          dispatch("conversation/handleMessageSent", data.datos, { root: true });
          break;
        case "message_send_error":
          dispatch("conversation/handleMessageSendError", data.datos, { root: true });
          break;
        case "message_delivered":
          dispatch("conversation/handleMessageDelivered", data.datos, { root: true });
          break;
        case "remove_from_chat":
          dispatch("chat/handleRemoveFromChat", data.datos, { root: true });
          if (!data.datos.hidden) {
            commit(
              'ui/alert/DISPLAY_ALERT',
              {
                title: 'Removido del grupo',
                message: 'Has sido removido de este grupo de chat',
                alertType: 'info'
              },
              { root: true }
            );
          }
          break;
        case "add_to_chat":
          dispatch("chat/handleAddToChat", data.datos, { root: true });
          break;
        case "new_transcription":
          commit("pbxCloud_store/newTranscription", data.datos, {
            root: true,
          });
          break;
        case "new_fexia_chat":
          commit("chat/ADD_FEXIA_SHARED_CHAT", data.datos, { root: true });
          break;
        case "reminder_notification": {
          const reminderData = data.data || {};
          console.log('[REMINDER] Evento recibido:', reminderData);
          console.log('[REMINDER] Notification.permission:', Notification.permission);
          commit('chat/REMOVE_CHAT_REMINDER', reminderData.sender_id, { root: true });
          if ('Notification' in window && Notification.permission === 'granted') {
            const n = new Notification('Recordatorio', {
              body: reminderData.subject || 'Tienes un recordatorio pendiente',
              icon: '/notification-logo.png',
              requireInteraction: false,
            });
            n.onclick = () => {
              window.focus();
              console.log('[REMINDER] onclick - hash actual:', window.location.hash);
              commit('chat/SET_PENDING_REMINDER_NAV', reminderData.sender_id, { root: true });
              commit('chat/SET_PENDING_JOIN_TAB', true, { root: true });
              console.log('[REMINDER] onclick - flags commiteados, sender_id:', reminderData.sender_id);
              if (!window.location.hash.startsWith('#/pbxCloud')) {
                console.log('[REMINDER] onclick - navegando a #/pbxCloud');
                window.location.hash = '#/pbxCloud';
              } else {
                console.log('[REMINDER] onclick - ya en pbxCloud, solo flags');
              }
            };
            setTimeout(() => n.close(), 15000);
          }
          break;
        }
        default:
          break;
      }
    },
    socketNotificationClose({ state, commit, dispatch }, { host="", userId="", close=false }) {
      if (state.isConnectedsipmovilNotiSocket === true) {
        state.sipmovilNotiSocket.close();
        if (close === false) {
          if (state.lastSipMovilDisconnectedTime === null) {
            state.lastSipMovilDisconnectedTime = new Date().getTime();
          }
          setTimeout(() => {
            if (state.isConnectedsipmovilNotiSocket === false) {
              commit(
                'ui/alert/DISPLAY_ALERT',
                {
                  title: 'Desconectado',
                  message: 'SipMóvil chat desconectado, por favor valide que su conexión este activa.',
                  alertType: 'error'
                },
                { root: true }
              )
            }
          }, 10000);
          setTimeout(() => {
            dispatch("openNotificationConnection",
              { host, userId }
            )
          }, 1000);
        }
      }
      commit("NOTIFICATION_SOCKET_ON_CLOSE");
      // setTimeout(router.go(), 10 * 1000);
    },
    /*
     -------- Apertura socket servidor Asterisk para las notificaciones -----------
    */
    openNotificatorConnection(
      { commit, dispatch, state },
      { notificator, account }
    ) {
        state.notificatorSocket = new WebSocket(
        `wss://${notificator}/ws/notifications/${account}/`
      );
      commit("NOTIFICATOR_SOCKET_ON_OPEN", state.notificatorSocket);

      state.notificatorSocket.onopen = () => {
        console.log('Websocket open successfully', state.notificatorSocket);
        commit('ui/alert/CLOSE_ALERT', null, { root: true });
      };

      state.notificatorSocket.onmessage = (event) => {
        // console.log('Websocket message received!', event);
        // console.log(event.data);
        dispatch("socketNotificatorMessage", event.data);
      };

      state.notificatorSocket.onclose = () => {
        dispatch("socketNotificatorClose", { notificator, account });
      };
    },
    sendNotificatorMessage({ state }, event) {
      // the message must be a Object
      const message = {};
      const extraData = {};
  
      Object.keys(event).forEach((key) => {
        if (key === "eventType") {
          message[camelToSnakeCase(key)] = event[key];
        } else {
          extraData[camelToSnakeCase(key)] = event[key];
        }
      });

      message.data = extraData;

      const parsedMessage = JSON.stringify(message);
      state.notificatorSocket.send(parsedMessage);
    },
    socketNotificatorMessage({ commit, dispatch, rootState }, e) {
      let { message } = JSON.parse(e);
      let data = message.data;
      let event = message.eventType;
      var channel_id = '';
      var invitationData = {};
      var labelData = {};
      var conferenceLabel = {};
      var phoneData = {};
      var memberData = {};
      var member = '';
      var conferenceId = '';
      switch (event) {
        case 'CALL_ID':
          console.log("[CRMCALL_TRACE] step=3 CALL_ID event arrived", {
            call_id: data.call_id,
            crmContext: rootState.softphone_store.crmContext,
          });
          // if (rootState.softphone_store.ctxSip.currentSession === null) {
          setTimeout(() => {
            rootState.softphone_store.ctxSip.currentSession.call_id = data.call_id;
            rootState.softphone_store.ctxSip.currentSession.numbers_in_call = data.numbers_in_call;
          }, 1000)
          // }
          dispatch('softphone_store/updateSecondUser', data.numbers_in_call, { root: true })
          dispatch('softphone_store/restartCallDuration', null, { root: true })
          if ('append_info' in data) {
            // update call info with aditional details
            dispatch('softphone_store/setCallEvents', data.append_info, { root: true })
          }
          if (rootState.softphone_store.crmContext) {
            console.log("[CRMCALL_TRACE] step=3b storing call_id in crmContext (POST deferred to hangup)");
            commit(
              'softphone_store/SET_CRM_CONTEXT_CALL_ID',
              data.call_id,
              { root: true }
            )
          } else {
            console.log("[CRMCALL_TRACE] step=3b SKIPPED: crmContext is null");
          }
          break;

        case 'UPDATE_CALL_EVENTS':
          dispatch('softphone_store/setCallEvents', data.call_events, { root: true })
          break;

        case 'INVITE_TRANFER':
          dispatch('softphone_store/setTranferParams', {
            'callId': data.call_id,
            'transferType': data.transfer_type
          }, { root: true })
          break

        case 'WARN_TRANSFER_ATTENDED':
          commit('softphone_store/ACTIVATE_TRANSFER', null, { root: true })
          break;

        case 'UPDATE_SOFTPHONE':
          
          if (data.label_1 != 'no_update') {
            labelData['status'] = data.label_1
          }
          if (data.label_2 != 'no_update') {
            labelData['label'] = data.label_2
          }
          if (data.label_3 != 'no_update') {
            labelData['info'] = data.label_3
          }
          commit('softphone_store/UPDATE_CALL_INFO', labelData, { root: true })
          break;

        case 'UPDATE_CONFERENCE_LABEL':

          if (data.label_1 != 'no_update') {
            conferenceLabel['status'] = data.label_1
          }
          if (data.label_2 != 'no_update') {
            conferenceLabel['label'] = data.label_2
          }
          if (data.label_3 != 'no_update') {
            conferenceLabel['info'] = data.label_3
          }
          commit('softphone_store/UPDATE_CONFERENCE_INFO', conferenceLabel, { root: true })
          break;

        case 'INIT_CONFERENCE':
          phoneData['status'] = data.label_1
          phoneData['label'] = data.label_2
          phoneData['info'] = data.label_3
          commit('softphone_store/UPDATE_CALL_INFO', phoneData, { root: true })
          // update conference info
          var conferenceData = {}
          conferenceData['conferenceId'] = data.conference_id
          conferenceData['conferenceStarted'] = data.conference_started
          conferenceData['userConferenceRole'] = data.conference_role
          commit('softphone_store/INIT_CONFERENCE', conferenceData, { root: true })
          break;

        case 'ADD_CONFERENCE_MEMBER':
          memberData['members'] = data.members
          memberData['conferenceId'] = data.conference_id
          memberData['extensionAdded'] = data.extension
          commit('softphone_store/ADD_CONFERENCE_MEMBER', memberData, { root: true })
          break;

        case 'REMOVE_CONFERENCE_MEMBER':
          member = data.member
          conferenceId = data.conference_id
          commit('softphone_store/REMOVE_CONFERENCE_MEMBER', { member, conferenceId }, { root: true })
          break;

        case 'SET_INVITED_CHANNEL':
          channel_id = data.channel_id
          commit('softphone_store/SET_PHONE_STATE', { phoneVar: 'invitedChannel', phoneState: channel_id }, { root: true })
          break

        case 'INVITED_REJECT':
          channel_id = data.channel_id
          commit('softphone_store/INVITED_REJECT', null, { root: true })
          break

        case 'SEND_CONFERENCE_INVITATION':
          invitationData['conferenceId'] = data.conference_id
          invitationData['invitorChannel'] = data.invitor_channel
          invitationData['invitedChannel'] = data.invited_channel
          invitationData['invitorEndpoint'] = data.invitor_endpoint
          commit('softphone_store/RECEIVE_CONFERENCE_INVITATION',
            invitationData, { root: true })
          break

        case 'HANGUP_CHANNELS':
          dispatch('softphone_store/hangupCall', null, { root: true })
          break

        case 'ENDPOINT_STATE':
          try {
            dispatch('chat/getPjsipContacts', { data }, {root: true});
          } catch {
            console.error("Not found endpoint", data);
          }
          break;

        case 'VOICEMESSAGE':
          commit("pbxCloud_store/loadVoiceMailCount", data.message_count, { root: true }),
          commit('pbxCloud_store/showSnackbarMessage', 'Tienes un nuevo correo de voz', { root: true })
          break;

        case 'ASTERISK_ERROR':
          commit('pbxCloud_store/showAlertMessage', 'error','Error', data.message, { root: true })
          break
      }
    },
    socketNotificatorClose({ state, commit, dispatch }, { notificator, account, close = false }) {
      if (state.isConnectednotificatorSocket === true) {
        state.notificatorSocket.close();
        if (close === false) {
          setTimeout(() => {
              if (state.isConnectednotificatorSocket === false) {
                commit(
                'ui/alert/DISPLAY_ALERT',
                { title: 'Desconectado',
                  message: 'Desconectado. por favor valide que su conexión este activa.',
                  alertType: 'error'},
                { root: true }
              )
            }
          }, 10000);
          setTimeout(function () {
            dispatch("openNotificatorConnection", { notificator, account });
          }, 1000);
        }
        commit("NOTIFICATOR_SOCKET_ON_CLOSE");
      }
      // setTimeout(router.go(), 10 * 1000);
    },

    openFexIANotificationConnection({ commit, dispatch, state }, { host, userId }) {
      state.sipmovilFexIANotiSocket = new WebSocket(
        `wss://${host}/ws/fexia-notification/${userId}/`
      );
      commit("FEXIA_NOTIFICATION_SOCKET_ON_OPEN", state.sipmovilFexIANotiSocket);
      state.sipmovilFexIANotiSocket.onopen = () => {
        console.log('Websocket open successfully', state.sipmovilFexIANotiSocket);
        commit('ui/alert/CLOSE_ALERT', null, { root: true });
      };

      state.sipmovilFexIANotiSocket.onmessage = (event) => {
        // console.log(event.data);
        dispatch("socketFexIANotificationMessage", event);
      };

      state.sipmovilFexIANotiSocket.onclose = () => {
        dispatch("socketFexIANotificationClose", { host, userId });
      };
    },
    sendFexIANotificationMessage({ state }, event) {
      const parsedMessage = JSON.stringify(event);
      state.sipmovilFexIANotiSocket.send(parsedMessage);
    },
    socketFexIANotificationMessage({ dispatch }, message) {
      const data = JSON.parse(message.data);
      let command = "";
      try {
        command = data.datos.command;
      } catch {
        command = data.command;
      }
      if (command === undefined) {
        command = data.event;
      }
      switch (command) {

        case "new_bot_message":
          dispatch("conversation/newFexIASipmovilChatMessage", data.datos, {
            root: true,
          });
          break;
        case "new_crm_fexia_message":
          dispatch("fxCrm_store/receiveCrmFexiaChunk", data.datos, {
            root: true,
          });
          break;
        default:
          break;
      }
    },
    socketFexIANotificationClose({ state, commit, dispatch }, { host = "", userId = "", close = false }) {
      if (state.isConnectedsipmovilFexIANotiSocket === true) {
        state.sipmovilFexIANotiSocket.close();
        if (close === false) {
          setTimeout(() => {
            if (state.isConnectedsipmovilFexIANotiSocket === false) {
              commit(
                'ui/alert/DISPLAY_ALERT',
                {
                  title: 'Desconectado',
                  message: 'SipMóvil chat desconectado, por favor valide que su conexión este activa.',
                  alertType: 'error'
                },
                { root: true }
              )
            }
          }, 10000);
          setTimeout(() => {
            dispatch("openFexIANotificationConnection",
              { host, userId }
            )
          }, 1000);
        }
      }
      commit("FEXIA_NOTIFICATION_SOCKET_ON_CLOSE");
      // setTimeout(router.go(), 10 * 1000);
    },
  },
};
function obtenerHora(fechaString) {
  const partes = fechaString.split(' ');
  const horaCompleta = partes[1];
  const [horas, minutos] = horaCompleta.split(':');
  return `${horas}:${minutos}`;
}

export default realtime;
